/**
 * TypeScript type definitions for dashboard chart components
 */

export const GROUP_BY_TYPE = {
  AGENT: "agent",
  MUTATION: "mutation",
  PERSONA: "persona",
  TEMPLATE: "template",
  TEST_SET: "test_set",
  ASSIGNEE: "assignee",
} as const

export type GroupByType = (typeof GROUP_BY_TYPE)[keyof typeof GROUP_BY_TYPE]
